<template>
  <div class="trans">
    <Header />
    <section class="register-page section-b-space mt90">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <form class="theme-form" v-on:submit="checkForm" method="post">
              <div v-if="errors.length">
                <ul class="validation-error mb-3">
                  <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                </ul>
              </div>
              <h2 class="text-center register-title">Add Phone number</h2>
              <div class="w-90">
                <div v-if="globalError">
                  <ul class="validation-error mb-3">
                    <li>{{globalError}}</li>
                  </ul>
                </div>
                <div class="form-group">
                  <label for="phone_number" class="border-label"><i class="fa fa-phone"></i></label>
                  <input
                      type="text"
                      class="bottom-input"
                      id="phone_number"
                      v-model="phone_number"
                      placeholder="Mobile Phone Number"
                      name="phone_number"
                      required
                  />
                </div>
                <div class="form-group">
                  <input
                      type="checkbox"
                      class="agree-term"
                      id="accepttc"
                      v-model="accepttc"
                      name="accepttc"
                  />
                  <label for="accepttc" class="label-agree-term"><span><span></span></span>I agree on all statements in <router-link to="/account/terms">Terms of Service</router-link></label>
                </div>
                <div class="form-group">
                  <input
                      type="checkbox"
                      class="agree-term"
                      id="notifysms"
                      v-model="notifysms"
                      name="notifysms"
                  />
                  <label for="notifysms">Allow SMS Notifications</label>
                </div>
                <div class="form-group mb-5">
                  <input
                      type="checkbox"
                      class="agree-term"
                      id="notifyemail"
                      v-model="notifyemail"
                      name="notifyemail"
                  />
                  <label for="notifyemail">Allow Email Notifications</label>
                </div>
                <div class="form-group d-flex justify-content-center">
                  <input
                      type="submit"
                      class="btn btn-register mt-5"
                      value="Continue"
                  >
                </div>
                <Pagination :number="2" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from '../../components/header'
import Footer from '../../components/footer'
import Pagination from '../../components/widgets/dot-pagination'

import {mapGetters} from "vuex";

import {signUp} from '@/utils/auth.js'

export default {
  components: {
    Header,
    Footer,
    Pagination
  },
  data() {
    return {
      errors: [],
      phone_number: "",
      accepttc: false,
      notifysms: true,
      notifyemail: true,
      useralreadyexists: 0,
    }
  },
  computed: {
    ...mapGetters({
      globalError: "getGlobalError",
      registration_data: 'auth/getRegistrationData',
      signup_phone_number: 'auth/signup_phone_number',
    }),
  },
  beforeDestroy() {
    this.reset_global_error();
  },
  watch: {
    globalError: async function() {
      if(this.globalError === 'User already exists') {
        this.useralreadyexists = 1;
        this.$store.dispatch("setGlobalError",{value:"User already exists. Continue to phone number verification."});
      }
    },
    signup_phone_number: async function() {
      this.phone_number = this.signup_phone_number;
    },
  },
  mounted() {
    this.$store.dispatch('auth/setSigninLog',{type: 'signup_page_2_opened', 'signinusername': ''});
    this.phone_number = this.signup_phone_number;
  },
  methods: {
    reset_global_error() {
      this.$store.dispatch("setGlobalError",{value:""});
    },
    checkForm: function (e) {
      this.errors = []
      if (!this.phone_number.length > 9) {
        this.errors.push('Phone number is required.')
      }
      if (!this.accepttc) {
        this.errors.push('Please read and accept Terms of Service to continue.')
      }
      e.preventDefault();
      if (!this.errors.length) {

        let clean_number = ('' + this.phone_number).replace(/\D/g, '');

        if(clean_number.length === 10) {
          this.phone_number = "+1" + clean_number;
        }
        if(clean_number.length === 11) {
          this.phone_number = "+" + clean_number;
        }
        this.$store.dispatch('auth/setRegistrationPart2', {phone_number: this.phone_number, tc_accepted: this.accepttc, sms_allowed: this.notifysms, email_allowed: this.notifyemail  })

        // This handles the issue where a user hits the back button from verify to phone number screen.
        if(this.useralreadyexists === 0) {
          signUp(this.registration_data.user_name, this.registration_data.password, this.registration_data.email, this.phone_number, this.$store);
          this.$store.dispatch('auth/setSigninLog',{type: 'signup_page_2', 'signinusername': '|error='+this.globalError+'|' + this.phone_number + '|' + this.registration_data.email + '|' + this.registration_data.user_name + '|'});
        }
        else {
          this.$store.dispatch('auth/setSigninLog',{type: 'signup_page_2_u_a_e', 'signinusername': '|error='+this.globalError+'|' + this.phone_number + '|' + this.registration_data.email + '|' + this.registration_data.user_name + '|'});
          this.$router.push({path: '/account/register_verify'})
        }

      }
    },
  }
}
</script>
